import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap'
import TemplateParametrizacao from './components/TemplateParametrizacao'
import TemplateComando from './components/TemplateComando'
import ButtonsForm from '../../components/ButtonsForm'
import CardParametrizacao from '../../components/CardParametrizacao'
import ProgressAcessos from '../../components/ProgressAcessos'
import CardComando from '../../components/CardComando'
import ConfirmDelete from '../../components/ConfirmDelete'
import { Link, Redirect } from 'react-router-dom'
import { components } from 'react-select'
import Select from '../../components/Select'
import helper from '../../utils/helper'
import cfg from '../../utils/config'
import auth from '../../utils/auth'
import axios from 'axios'
import tourManager from '../../tours'
import demoSession from '../../tours/demo/DemoSession'

import ModalEmail from './components/ModalEmails'
import CardErrorParametrizacao from '../../components/CardErrorParametrizacao'
import MqttPreview from './components/MqttPreview/MqttPreview'

import EditableCardParametrizacao from './components/EditableCardParametrizacao'
import GenericModal from '../../components/GenericModal'
import ModalAvisoTimestampBuffer from '../../components/ModalAvisoTimestampBuffer'
import ConfirmarEmailModal from '../../components/ConfirmarEmailModal'
import { verificarEmailConfirmado } from '../../services/confirmacaoEmail'

class Form extends Component {
    userInfo = auth.getUserInfo()
    configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
    baseUrl = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa

    state = {
        detalhes: {
            imei: "", fabricante: null, modelo: null, operadora: null, sim_card: "", status: "",
            tipo_comunicacao: "", gateway: null, isGateway: false, gateway_equipamento: "", acesso: "",
            topico_personalizado: false, topico_publica: "", topico_recebe: "", usuario_mqtt: "", senha_mqtt: "",
            campo_gateway: "", tipo_acesso: "", tempo_limite_sem_comunicacao: 0, decoder: null
        },
        comandos: [],
        parametrizacoes: [],
        fabricantes: [],
        modelos: [],
        operadoras: [],
        decoders: [],
        tipoAcessos: [],
        acessos: [],
        timezones: [],
        gateways: [],
        redirect: false,
        allowNewParam: true,
        path: "",
        tab: 0,
        modalAcesso: false,
        optionSelected: {
            fabricante: {}, modelo: {}, operadora: {}, tipo_acesso: {}, decoder: null,
            timezone: { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo' }
        },
        cooldown: false,
        modalConfirmTopicoPersonalizado: false,
        topicoPersonalizadoSalvo: false,
        modalTopicoPub: false,
        modalTopicoSub: false,
        pubExtras: [],
        subExtras: [],
        novoTopicoPub: "",
        novoTopicoSub: "",
        editandoTopicoPub: null,
        editandoTopicoSub: null,
        valorEditandoPub: "",
        valorEditandoSub: "",
        alterarSenha: false,
        validacao: false,
        acaoAcesso: "",
        interval: null,
        device_id: "{device_id}",
        isVirtual: false,
        back_to: false,
        emails_notificar: [],
        cards_errors_import: [],
        savedCommunicationType: null,
        parametrosImportados: [],
        is_importando: false,
        comunicou: null,
        parametrosCarregados: false,
        proximaVerificacao: 30,
        intervaloContador: null,
        pendingNovoCadastro: false,
        modalConfirmarEmail: { isOpen: false, email: null },
        emailsIgnorados: [],
        equipamentoCarregado: !Boolean(this.props.match?.params?.id),
        modalAvisoBuffer: false,
        modalConfirmarSemBuffer: false,
        salvandoBufferAviso: false,
    }

    componentWillMount = () => {
        this.getTipoAcessos()
    }

    componentWillUnmount = () => {
        clearInterval(this.state.interval)
        clearInterval(this.state.intervaloContador)
    }

    componentDidMount = () => {
        if (this.props.match.params.id) {
            this.getData()

            const url = window.location.search
            const urlSearchParams = new URLSearchParams(url)

            try {
                const back_to = urlSearchParams.get('back_to')
                if (back_to) {
                    this.setState({back_to})
                }
            } catch (erro) {
                console.log(erro)
            }

            try {
                const protocolo = urlSearchParams.get('protocolo')
                if (protocolo) {
                    this.setState({ tab: 1 })
                }
            } catch (erro) {
                console.log(erro)
            }
        }

        try {
            this.getInitialData()
            const hash = window.location.hash.replace("#", "")
            if (hash) {
                this.setState({ tab: Number(hash) - 1 })
            }
        } catch (err) {
            console.error(err)
        }

        this.getGateways()
    }

    componentDidUpdate = (prevProps, prevState) => {
        const avisoEraNecessario = this.deveExibirAvisoBuffer(prevState)
        const avisoAgoraNecessario = this.deveExibirAvisoBuffer(this.state)

        if (
            this.state.tab === 2 &&
            !avisoEraNecessario &&
            avisoAgoraNecessario &&
            !this.state.modalAvisoBuffer &&
            !this.state.modalConfirmarSemBuffer
        ) {
            this.setState({ modalAvisoBuffer: true })
        }
    }

    getData = async () => {
        const baseUrl = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa

        axios.get(baseUrl + '/equipamento/' + this.props.match.params.id + '/', this.configMe)
            .then((res) => {
                axios.get(baseUrl + '/fabricante/' + res.data.fabricante?.id + '/modelo/', this.configMe)
                    .then((modelos) => {
                        let equipamento = res.data
                        let optionsModelos = []
                        let optionObj = this.state.optionSelected
                        let detalhes = Object.assign(this.state.detalhes, equipamento)
                        const communicationType = res.data.tipo_comunicacao;

                        if (modelos.status === 200) {
                            modelos.data?.results?.forEach((m) => optionsModelos.push({ "value": m.id, "label": m.modelo }))
                        }

                        let optionGateway

                        optionObj["fabricante"] = { "value": equipamento.fabricante?.id ?? null, "label": equipamento?.fabricante?.nome }
                        optionObj["modelo"] = { "value": equipamento.modelo?.id ?? null, "label": equipamento?.modelo?.modelo }
                        optionObj["operadora"] = { "value": equipamento.operadora?.id ?? null, "label": equipamento?.operadora?.nome, possui_chip: equipamento?.operadora?.possui_chip }
                        optionObj["tipo_acesso"] = { "value": equipamento.acesso?.acesso_tipo ?? null, "label": equipamento?.acesso?.acesso_tipo__descricao }
                        optionObj["decoder"] = equipamento.decoder ? { "value": equipamento.decoder.id, "label": equipamento.decoder.descricao } : null
                        equipamento?.validacao?.timezone_equipamento ? optionObj["timezone"] = { "value": equipamento?.validacao?.timezone_equipamento, "label": equipamento?.validacao?.timezone_equipamento } : null

                        if (equipamento.gateway_equipamento != null) {
                            optionGateway = this.state.gatewayOptions.filter((value) => {
                                return value.value === equipamento.gateway_equipamento
                            })

                            detalhes["gateway"] = optionGateway[0]
                        }

                        if (equipamento.gateway) {
                            detalhes['campo_gateway'] = equipamento?.campo_identificacao_gateway_equipamento
                        }

                        detalhes['isGateway'] = equipamento.gateway
                        detalhes["tipo_acesso"] = equipamento?.acesso?.acesso_tipo

                        if (equipamento.validacao && 'tempo_limite_sem_comunicacao' in equipamento.validacao) {
                            detalhes["tempo_limite_sem_comunicacao"] = equipamento.validacao.tempo_limite_sem_comunicacao
                        } else {
                            detalhes["tempo_limite_sem_comunicacao"] = 0
                        }

                        this.setState({
                            detalhes: detalhes,
                            modelos: optionsModelos,
                            optionSelected: optionObj,
                            device_id: equipamento.usuario_mqtt,
                            isVirtual: equipamento.modelo.id === 8,
                            emails_notificar: res.data.validacao?.emails_notificar ?? [],
                            savedCommunicationType: communicationType,
                            pubExtras: equipamento.pub_extras ?? equipamento.validacao?.pub_extras ?? [],
                            subExtras: equipamento.sub_extras ?? equipamento.validacao?.sub_extras ?? [],
                            topicoPersonalizadoSalvo: Boolean(equipamento.topico_personalizado),
                        }, () => {
                            this.getDecoders(equipamento.modelo?.id)
                            Promise.all([
                                this.buscarUltimoReporte(),
                                this.getParametros(),
                            ]).finally(() => {
                                this.setState({ equipamentoCarregado: true })
                            })
                        })
                    })
            })
    }

    getTipoAcessos = () => {
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        let userInfo = auth.getUserInfo()

        axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + "/acesso/tipo/", config_me).then((res) => {
            let tipoAcessos = []
            let seen = new Set();

            res.data.forEach((acesso) => {
                if (!seen.has(acesso.acesso_tipo__id)) {
                    tipoAcessos.push({ label: acesso.acesso_tipo__descricao, value: acesso.acesso_tipo__id })
                    seen.add(acesso.acesso_tipo__id)
                }
            })

            this.setState({ tipoAcessos })
        })
    }

    getDecoders = (modeloId) => {
        if (!modeloId) {
            this.setState({ decoders: [] })
            return
        }

        const base = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}`

        axios.get(base + '/decoder/?modelo=' + modeloId, this.configMe).then((res) => {
            let decoderOptions = []

            if (res.status === 200) {
                res.data?.results?.forEach((decoder) => {
                    decoderOptions.push({ "value": decoder.id, "label": decoder.descricao })
                })
            }

            this.setState({ decoders: decoderOptions })
        })
    }

    getInitialData = async () => {
        const base = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}`
        let requestArray = [
            axios.get(base + '/operadora/', this.configMe),
            axios.get(base + '/fabricante/', this.configMe),
            axios.get(base + '/equipamento/?gateway=true', this.configMe),
            axios.get(base + '/configuracao-timezone/', this.configMe)
        ]

        await axios.all(requestArray).then(axios.spread((operadoras, fabricantes, gateways, timezones) => {
            let optionsFabricantes = []
            let optionsOperadoras = []
            let gatewayOptions = []
            let timezoneOptions = []

            if (fabricantes.status === 200) {
                fabricantes.data?.results?.forEach((fabricante) => {
                    optionsFabricantes.push({ "value": fabricante.id, "label": fabricante.nome })
                })
            }

            if (operadoras.status === 200) {
                operadoras.data?.results?.forEach((operadora) => {
                    optionsOperadoras.push({ "value": operadora.id, "label": operadora.nome, "possui_chip": operadora.possui_chip })
                })
            }

            if (gateways.status === 200) {
                gateways.data?.results?.forEach((gateway) => {
                    gatewayOptions.push({ label: gateway.imei, value: gateway.id })
                })
            }

            if (timezones.status === 200) {
                timezones.data?.results?.forEach((timezone) => {
                    timezoneOptions.push({ label: timezone.codigo, value: timezone.codigo })
                })
            }

            this.setState({ gatewayOptions, fabricantes: optionsFabricantes, operadoras: optionsOperadoras, timezones: timezoneOptions })
        }))

        if (this.props.match.params.id) {
            this.getComandos()
        }

        setTimeout(() => this.getParametros(), 150)
    }

    getComandos = () => {
        const base = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}`
        const equipamentoId = String(this.props.match.params.id)

        axios.get(base + '/comando-customizado/?limit=100&equipamento=' + equipamentoId, this.configMe).then((res) => {
            let comandos = []

            if (res.status === 200) {
                res.data.results.forEach((comando) => {
                    comando.parametros = helper.parseComandoParametros(comando?.parametros)
                    comandos.push(comando)
                })
            }

            this.setState({ comandos: comandos })
        })
    }

    getParametros = () => {
        if (!this.props.match.params.id) return
        const base = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}`
        const equipamentoId = String(this.props.match.params.id)

        return axios.get(base + '/campo-customizado/?limit=100&equipamento=' + equipamentoId, this.configMe).then((res) => {
            let { acessos, detalhes } = this.state
            let parametrizacoesItens = []
            let allowNewParam = true

            if (res.status === 200) {
                parametrizacoesItens = res.data.results ?? []

                if (detalhes?.acesso) {
                    let { limite } = this.state.detalhes?.acesso
                    if (parametrizacoesItens?.length == limite) {
                        allowNewParam = false
                    } else {
                        allowNewParam = parametrizacoesItens?.length < detalhes?.acesso?.limite
                    }
                }
            }

            this.setState({
                parametrizacoes: parametrizacoesItens,
                allowNewParam,
                parametrosCarregados: true,
            })
        })
    }

    handleChangeFabricante = (selectedOption, field) => {
        let obj = this.state.detalhes
        let optionObj = this.state.optionSelected
        obj[field] = selectedOption.value
        optionObj[field] = selectedOption
        obj["modelo_id"] = ""
        optionObj["modelo"] = ""
        obj["decoder"] = null
        optionObj["decoder"] = null

        axios({
            url: cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/fabricante/' + optionObj.fabricante?.value + '/modelo/',
            method: "GET",
            ...this.configMe
        }).then((res) => {
            let optionsModelos = []
            if (res.status === 200) {
                res.data.results.forEach((a) => optionsModelos.push({ "value": a.id, "label": a.modelo }))
            }

            this.setState({ "optionSelected": optionObj, "detalhes": obj, "modelos": optionsModelos, "decoders": [] })
            document.querySelector(`#validacao-${field}`).innerHTML = ""
        })
    }

    handleChangeModelo = (selectedOption, field) => {
        let obj = this.state.detalhes
        let optionObj = this.state.optionSelected
        obj[field] = selectedOption.value
        optionObj[field] = selectedOption
        obj["decoder"] = null
        optionObj["decoder"] = null

        document.querySelector(`#validacao-${field}`).innerHTML = ""
        this.setState({ "optionSelected": optionObj, "detalhes": obj })
        this.getDecoders(selectedOption.value)
    }

    handleChangeSelect = (selectedOption, field) => {
        let obj = this.state.detalhes
        obj[field] = selectedOption.value
        let optionObj = this.state.optionSelected
        optionObj[field] = selectedOption
        document.querySelector(`#validacao-${field}`).innerHTML = ""
        this.setState({ "optionSelected": optionObj, "detalhes": obj })
    }

    isFormularioPreenchido = () => {
        const { detalhes, isVirtual } = this.state
        let campos = ['imei', 'fabricante', 'modelo', 'operadora', 'status']

        if (isVirtual) campos = campos.filter((campo) => campo !== 'operadora')
        if (detalhes.isGateway) {
            campos.push('campo_gateway')
        } else if (detalhes.status === 'ativo') {
            campos.push('tipo_acesso')
        }

        if (campos.some((campo) => !detalhes[campo])) return false
        if (!this.props.match.params.id && !detalhes.tipo_comunicacao) return false
        if (detalhes.tipo_comunicacao === 'via_gateway' && !detalhes.gateway) return false

        return true
    }

    validation = () => {
        const { detalhes, isVirtual } = this.state
        let erro = false
        let data = {}
        let arrayData = ['imei', 'fabricante', 'modelo', 'operadora', 'status']

        if (!detalhes.isGateway && detalhes.status === 'ativo') {
            arrayData.push('tipo_acesso')
        } else {
            let field_acesso = document.getElementById(`validacao-tipo_acesso`)
            if (field_acesso) field_acesso.innerHTML = ""
        }

        if (detalhes.isGateway) arrayData.push('campo_gateway')
        if (isVirtual) arrayData = arrayData.filter((parametro) => parametro !== 'operadora')

        arrayData.forEach((valor) => data[valor] = detalhes[valor])

        for (let i in data) {
            let field = document.getElementById(`validacao-${i}`)
            if (!data[i]) {
                erro = true
                if (field) field.innerHTML = "Campo não pode ser nulo!"
            } else {
                if (field) field.innerHTML = ""
            }
        }

        if (!this.props.match.params.id) {
            const fieldProtocolo = document.getElementById('validacao-tipo_comunicacao')
            if (!detalhes.tipo_comunicacao) {
                if (fieldProtocolo) fieldProtocolo.innerHTML = "Escolha um protocolo de comunicação!"
                erro = true
            } else {
                if (fieldProtocolo) fieldProtocolo.innerHTML = ""
            }
        }

        if (detalhes.tipo_comunicacao === 'via_gateway') {
            const fieldGateway = document.getElementById('validacao-gateway_equipamento')
            if (!detalhes.gateway) {
                if (fieldGateway) fieldGateway.innerHTML = "Selecione um gateway!"
                erro = true
            } else {
                if (fieldGateway) fieldGateway.innerHTML = ""
            }
        }

        return erro
    }

    saveImport = () => {
        if (this.state.parametrosImportados.some(parametro => !parametro.descricao?.trim())) {
            return
        }

        const url = `${this.baseUrl}/equipamento/${this.props.match.params.id}/parametros/importar/`
        const body_data = { parametros: this.state.parametrosImportados }

        axios({
            url: url,
            method: "POST",
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() },
            data: body_data
        })
        .then(response => {
            const { erros = [], quantidade_permitida, sucessos = [] } = response.data

            if (Array.isArray(erros) && erros.length > 0) {
                helper.dispatchEvent("showAviso", { message: erros[0]?.motivo_erro ?? "Alguns parâmetros não puderam ser importados." })
                this.setState({ cards_errors_import: erros, is_importando: false })

                if (sucessos.length > 0) {
                    this.getParametros()
                }
                return
            }

            helper.dispatchEvent("showAviso", { message: "Parâmetros importados com sucesso." })
            this.setState({ cards_errors_import: [], parametrosImportados: [], is_importando: false })
            this.getParametros()
        })
        .catch(error => {
            const data = error?.response?.data ?? {}
            const erros = data.erros ?? []

            if (Array.isArray(erros) && erros.length > 0) {
                helper.dispatchEvent("showAviso", { message: erros[0]?.motivo_erro ?? "Alguns parâmetros não puderam ser importados." })
                this.setState({ cards_errors_import: erros, is_importando: false })
                return
            }

            const message_error = data.detail ?? "Não foi possível importar os parâmetros."
            helper.dispatchEvent("showAviso", { message: message_error })
            this.setState({ is_importando: false, parametrosImportados: []})
        })
    }

    subirParametrosImportados = (parametrosImportados) => {
        this.setState({ parametrosImportados, is_importando: true})
    }

    updateParametroImportado = (index, field, value) => {
        let { parametrosImportados } = this.state
        parametrosImportados = parametrosImportados.map((parametro, idx) => {
            if (idx !== index) return parametro
            const updated = { ...parametro, [field]: value }

            if (field === 'descricao') {
                updated.identificacao = helper.toSnakeCase(value)
            }

            return updated
        })

        this.setState({ parametrosImportados })
    }

    removerParametroImportado = (index) => {
        const { parametrosImportados } = this.state
        const updated = parametrosImportados.filter((_, idx) => idx !== index)
        this.setState({ parametrosImportados: updated })
    }

    saveAction = async (novoCadastro) => {
        if (this.validation()) {
            const { detalhes, tab } = this.state
            const isNew = !this.props.match.params.id

            const camposEquipamento = ['imei', 'fabricante', 'modelo', 'operadora', 'status', 'tipo_acesso', 'campo_gateway']
            const erroNaEquipamento = camposEquipamento.some(campo => {
                const span = document.getElementById(`validacao-${campo}`)
                return span && span.innerHTML.trim() !== ""
            })

            if (erroNaEquipamento) {
                if (tab !== 0) this.setState({ tab: 0 }, () => this.validation())
                return
            }

            const erroNaProtocolo =
                (isNew && !detalhes.tipo_comunicacao) ||
                (detalhes.tipo_comunicacao === 'via_gateway' && !detalhes.gateway)

            if (erroNaProtocolo) {
                if (tab !== 1) this.setState({ tab: 1 }, () => this.validation())
                return
            }

            return
        }

        for (const item of this.state.emails_notificar) {
            const email = item?.email
            if (!email || this.state.emailsIgnorados.includes(email)) continue

            try {
                const confirmado = await verificarEmailConfirmado(email)
                if (!confirmado) {
                    this.setState({
                        pendingNovoCadastro: novoCadastro,
                        modalConfirmarEmail: { isOpen: true, email }
                    })
                    return
                }
            } catch (error) {
                helper.dispatchEvent("showAviso", { message: "Não foi possível verificar o e-mail. Tente novamente." })
                return
            }
        }

        const { detalhes, optionSelected } = this.state
        this.setState({ cooldown: true })
        let requestURL = ""
        let verb = ""

        if (this.props.match.params.id) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/equipamento/' + this.props.match.params.id + '/'
            verb = 'patch'
        } else {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/equipamento/'
            verb = 'post'
        }

        const payload = {
            imei: detalhes.imei?.trim(),
            fabricante: optionSelected?.fabricante?.value ?? null,
            modelo: optionSelected?.modelo?.value ?? null,
            operadora: optionSelected?.operadora?.value ?? null,
            timezone: optionSelected?.timezone?.value ?? null,
            decoder: optionSelected?.decoder?.value ?? null,
            sim_card: detalhes.sim_card,
            status: detalhes.status,
            tipo_acesso: detalhes.tipo_acesso,
            tipo_comunicacao: detalhes.tipo_comunicacao,
            gateway: detalhes.isGateway ? "1" : "0",
            topico_personalizado: detalhes.topico_personalizado,
            tempo_limite_sem_comunicacao: detalhes.tempo_limite_sem_comunicacao,
            emails_notificar: this.state.emails_notificar,
            pub_extras: this.state.pubExtras,
            sub_extras: this.state.subExtras,

            ...(detalhes.validacao?.buffer_aviso_dispensado === true && {
                buffer_aviso_dispensado: true,
            }),

            ...(detalhes.isGateway && {
                campo_identificacao_gateway_equipamento: detalhes.campo_gateway,
            }),

            ...(detalhes.tipo_comunicacao === "via_gateway" && {
                gateway_equipamento: detalhes.gateway?.value ?? null,
            }),

            ...(detalhes.tipo_comunicacao === "mqtt" && detalhes.topico_personalizado && {
                topico_recebe: detalhes.topico_recebe,
                topico_publica: detalhes.topico_publica,
            }),

            ...(verb === "patch" && {
                reset_password: this.state.alterarSenha,
                ...(Boolean(detalhes?.acesso?.acesso_tipo) && detalhes?.acesso?.acesso_tipo !== detalhes.tipo_acesso && {
                    old_acesso: detalhes?.acesso?.id,
                    tipo_acesso: detalhes.tipo_acesso,
                }),
            }),
        }

        axios({
            method: verb,
            url: requestURL,
            data: payload,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (novoCadastro) {
                window.location.reload()
            } else {
                this.setState({ topicoPersonalizadoSalvo: Boolean(detalhes.topico_personalizado) })
                const isDemoMode = demoSession.isActive()
                helper.dispatchEvent("showAviso", {
                    message: `Equipamento ${verb === "post" ? "criado" : "editado"} com sucesso.`,
                    callback: () => this.setState({ redirect: true, path: "/equipamento" }),
                    callbackClose: verb === "post" && !isDemoMode ?
                        () => {
                            window.location.href = `/equipamento/${res.data.id}/editar?protocolo=true`
                            setTimeout(() => { window.location.reload() }, 1000)
                        }
                        :
                        verb === "post" ? null : () => {
                            let acessoIdAtual = detalhes.acesso.id
                            let acessoIdRecebido = res.data.acesso.id

                            if (acessoIdAtual !== acessoIdRecebido) {
                                window.location.reload()
                            } else if (this.state.alterarSenha) {
                                this.getData()
                            }
                        }
                })
            }
        }).catch((error) => {
            let erros = Object.entries(error.response.data)

            if (error.response.data.code === 33) {
                let message = error.response.data.message
                let callback = () => this.setState({ redirect: true, path: "/equipamento" })
                helper.dispatchEvent(("showAviso", { message, callback }))
            }

            if (error.response.data.code === 34) {
                let message = error.response.data.message
                let callback = () => this.setState({ redirect: true, path: "/acessos" })
                helper.dispatchEvent(("showAviso", { message, callback }))
            }

            if (Array.isArray(erros)) {
                for (let i = 0; i < erros.length; i++) {
                    if (erros[i][0] === "detail") {
                        helper.dispatchEvent("showAviso", {
                            message: erros[i][1],
                            callback: () => this.setState({ redirect: true, path: "/equipamento" }),
                            callbackClose: () => {
                                window.location.href = `/equipamento`
                            }
                        })
                    } else {
                        let span = document.querySelector(`#validacao-${erros[i][0]}`)
                        if (span) span.innerHTML = erros[i][1]
                    }
                }
            }
        })

        setTimeout(() => this.setState({ cooldown: false }), 1000)
    }

    handleEmailConfirmado = () => {
        this.setState({ modalConfirmarEmail: { isOpen: false, email: null } })
        this.saveAction(this.state.pendingNovoCadastro)
    }

    handleContinuarSemConfirmar = () => {
        const email = this.state.modalConfirmarEmail.email
        this.setState({
            modalConfirmarEmail: { isOpen: false, email: null },
            emailsIgnorados: [...this.state.emailsIgnorados, email]
        }, () => this.saveAction(this.state.pendingNovoCadastro))
    }

    handleChange = (e) => {
        let obj = { ...this.state.detalhes }
        let acao

        obj[e.target.id] = e.target.type === "checkbox" ? e.target.checked : e.target.value

        if (e.target.value === "ativo") {
            acao = "somar"
        } else {
            acao = "subtrair"
        }

        this.setState({ "detalhes": obj, "acaoAcesso": acao })
        if (document.querySelector(`#validacao-${e.target.name}`)) {
            document.querySelector(`#validacao-${e.target.name}`).innerHTML = ""
        }
    }

    buscarUltimoReporte = () => {
        if (!this.props.match.params?.id) return

        return axios({
            method: "GET",
            url: `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/equipamento/${this.props.match.params.id}/historico/`,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (res.status !== 200) return

            const comunicou = res.data?.last_report !== "null" && res.data?.last_report != null

            if (comunicou) {
                clearInterval(this.state.intervaloContador)
                this.setState({ comunicou: true, intervaloContador: null })
            } else {
                this.setState({ comunicou: false }, () => {
                    this.iniciarContadorVerificacao()
                })
            }
        }).catch(console.error)
    }

    iniciarContadorVerificacao = () => {
        clearInterval(this.state.intervaloContador)
        this.setState({ proximaVerificacao: 30 })

        const intervaloContador = setInterval(() => {
            this.setState((prevState) => {
                const proximo = prevState.proximaVerificacao - 1

                if (proximo <= 0) {
                    clearInterval(prevState.intervaloContador)
                    setTimeout(() => this.buscarUltimoReporte(), 0)
                    return { proximaVerificacao: 30, intervaloContador: null }
                }

                return { proximaVerificacao: proximo }
            })
        }, 1000)

        this.setState({ intervaloContador })
    }

    handleChangeGateway = (e) => {
        let { detalhes } = this.state
        detalhes["gateway"] = e
        this.setState({ detalhes })
    }

    adicionarTopicoPub = () => {
        const { novoTopicoPub, pubExtras } = this.state

        if (!novoTopicoPub.trim()) return

        this.setState({
            pubExtras: [...pubExtras, novoTopicoPub.trim()],
            novoTopicoPub: ""
        })
    }

    removerExtraPub = (indexToRemove) => {
        this.setState((prevState) => ({
            pubExtras: prevState.pubExtras.filter(
                (_, currentIndex) => currentIndex !== indexToRemove
            )
        }));
    }

    adicionarTopicoSub = () => {
        const { novoTopicoSub, subExtras } = this.state

        if (!novoTopicoSub.trim()) return

        this.setState({
            subExtras: [...subExtras, novoTopicoSub.trim()],
            novoTopicoSub: ""
        })
    }

    removerExtraSub = (indexToRemove) => {
        this.setState((prevState) => ({
            subExtras: prevState.subExtras.filter(
                (_, currentIndex) => currentIndex !== indexToRemove
            )
        }))
    }

    confirmarEdicaoPub = (index) => {
        const { pubExtras, valorEditandoPub } = this.state
        const updated = pubExtras.map((t, i) => i === index ? valorEditandoPub : t)
        this.setState({ pubExtras: updated, editandoTopicoPub: null, valorEditandoPub: "" })
    }

    confirmarEdicaoSub = (index) => {
        const { subExtras, valorEditandoSub } = this.state
        const updated = subExtras.map((t, i) => i === index ? valorEditandoSub : t)
        this.setState({ subExtras: updated, editandoTopicoSub: null, valorEditandoSub: "" })
    }


    deveExibirAvisoBuffer = (state = this.state) => {
        if (tourManager.isActive() || demoSession.isActive()) return false

        const timestampCadastrado = state.parametrizacoes?.some(
            (parametro) => parametro.identificacao === "timestamp_dispositivo"
        )

        return (
            state.equipamentoCarregado &&
            state.parametrosCarregados &&
            state.comunicou === true &&
            !timestampCadastrado &&
            state.detalhes?.validacao?.buffer_aviso_dispensado !== true
        )
    }

    abrirAvisoBuffer = () => {
        if (!this.deveExibirAvisoBuffer()) return false

        this.setState({ modalAvisoBuffer: true })
        return true
    }

    handleTab = (index) => {
        this.setState({ tab: index }, () => {
            if (index === 2) this.abrirAvisoBuffer()
        })
    }

    cadastrarTimestampDispositivo = () => {
        const equipamentoId = this.state.detalhes.id ?? this.props.match.params.id

        this.setState({ modalAvisoBuffer: false }, () => {
            this.props.history.push({
                pathname: `/campo-parametrizado/${equipamentoId}/novo`,
                state: {
                    id: equipamentoId,
                    prefill: {
                        descricao: "timestamp dispositivo",
                        identificador: "timestamp_dispositivo",
                    },
                },
            })
        })
    }

    dispensarAvisoBuffer = () => {
        if (this.state.salvandoBufferAviso) return

        const equipamentoId = this.state.detalhes.id ?? this.props.match.params.id
        this.setState({ salvandoBufferAviso: true })

        axios.patch(
            `${this.baseUrl}/equipamento/${equipamentoId}/`,
            { buffer_aviso_dispensado: true },
            this.configMe
        ).then((res) => {
            this.setState((prevState) => ({
                detalhes: {
                    ...prevState.detalhes,
                    validacao: {
                        ...prevState.detalhes.validacao,
                        ...res.data?.validacao,
                        buffer_aviso_dispensado: true,
                    },
                },
                modalAvisoBuffer: false,
                modalConfirmarSemBuffer: false,
                salvandoBufferAviso: false,
            }))
        }).catch((error) => {
            this.setState({ salvandoBufferAviso: false })
            helper.dispatchEvent("showAviso", {
                message: error?.response?.data?.detail || "Não foi possível dispensar o aviso de buffer. Tente novamente.",
            })
        })
    }

    renderComunicacao = () => {

        const { detalhes, pubExtras, subExtras, novoTopicoPub, novoTopicoSub, modalTopicoPub, modalTopicoSub } = this.state
        const isEditing = Boolean(this.props.match.params.id)
        const btnPubDisabled = !isEditing && !detalhes.topico_personalizado

        const btnSubDisabled = !isEditing && !detalhes.topico_personalizado

        const btnSenhaDisabled = !isEditing

        if (detalhes.tipo_comunicacao === "mqtt") {
            return (
                <div className="row">
                    <GenericModal
                        isOpen={this.state.modalConfirmTopicoPersonalizado}
                        description="Ao habilitar essa opção e salvar, essa ação não poderá ser desfeita. Deseja continuar?"
                        confirmClassName="hdv-btn-green"
                        onClose={() =>
                            this.setState({ modalConfirmTopicoPersonalizado: false })
                        }
                        onConfirm={() => {
                            const detalhes = { ...this.state.detalhes }
                            detalhes.topico_personalizado = true

                            this.setState({
                                detalhes,
                                modalConfirmTopicoPersonalizado: false
                            })
                        }}
                    />
                    <Modal size="lg" isOpen={modalTopicoPub} toggle={() => this.setState({ modalTopicoPub: false })}>
                        <ModalHeader toggle={() => this.setState({ modalTopicoPub: false })}>
                            Adicionar tópicos extras de Publicação
                        </ModalHeader>
                        <ModalBody>
                            <div className="d-flex align-items-center mb-3 justify-content-between hdv-gap-md">
                                <input
                                    type="text"
                                    className="input w-75"
                                    placeholder="Novo tópico publicar"
                                    value={novoTopicoPub}
                                    onChange={(e) => this.setState({ novoTopicoPub: e.target.value })}
                                    onKeyDown={(e) => { if (e.key === 'Enter') this.adicionarTopicoPub() }}
                                />
                                <button className="hdv-btn-forms hdv-btn-green hdv-nowrap m-0" onClick={this.adicionarTopicoPub}>
                                    Adicionar
                                </button>
                            </div>
                            {pubExtras.length === 0
                                ? <p className="text-muted p-1">Nenhum tópico extra cadastrado.</p>
                                : (
                                    <table className="afira-table">
                                        <thead>
                                            <tr>
                                                <th>Tópicos de publicação extras</th>
                                                <th style={{ width: 120 }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pubExtras.map((topicoPublicacao, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        {this.state.editandoTopicoPub === index
                                                            ? (
                                                                <input
                                                                    type="text"
                                                                    className="input"
                                                                    value={this.state.valorEditandoPub}
                                                                    onChange={(e) => this.setState({ valorEditandoPub: e.target.value })}
                                                                    onKeyDown={(e) => { if (e.key === 'Enter') this.confirmarEdicaoPub(index) }}
                                                                />
                                                            )
                                                            : (
                                                                <span title={topicoPublicacao}>
                                                                    {topicoPublicacao}
                                                                </span>
                                                            )
                                                        }
                                                    </td>
                                                    <td className="hdv-subtable-action-td" style={{ textAlign: "center" }}>
                                                        {this.state.editandoTopicoPub === index
                                                            ? (
                                                                <button
                                                                    className="hdv-btn-forms hdv-btn-green"
                                                                    onClick={() => this.confirmarEdicaoPub(index)}
                                                                >
                                                                    Salvar
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="hdv-btn-forms hdv-btn-yellow"
                                                                    onClick={() => this.setState({ editandoTopicoPub: index, valorEditandoPub: topicoPublicacao })}
                                                                >
                                                                    Editar
                                                                </button>
                                                            )
                                                        }
                                                        <ConfirmDelete
                                                            enabled={true}
                                                            action={() => this.removerExtraPub(index)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )
                            }
                        </ModalBody>
                        <ModalFooter>
                            <button className="hdv-btn-forms hdv-btn-blue" onClick={() => this.setState({ modalTopicoPub: false, editandoTopicoPub: null })}>
                                Fechar
                            </button>
                        </ModalFooter>
                    </Modal>

                    <Modal size="lg" isOpen={modalTopicoSub} toggle={() => this.setState({ modalTopicoSub: false })}>
                        <ModalHeader toggle={() => this.setState({ modalTopicoSub: false })}>
                            Adicionar tópicos extras de Recepção
                        </ModalHeader>
                        <ModalBody>
                            <div className="d-flex align-items-center mb-3 justify-content-between hdv-gap-md">
                                <input
                                    type="text"
                                    className="input w-75"
                                    placeholder="Novo tópico receber"
                                    value={novoTopicoSub}
                                    onChange={(e) => this.setState({ novoTopicoSub: e.target.value })}
                                    onKeyDown={(e) => { if (e.key === 'Enter') this.adicionarTopicoSub() }}
                                />
                                <button className="hdv-btn-forms hdv-btn-green hdv-nowrap m-0" onClick={this.adicionarTopicoSub}>
                                    Adicionar
                                </button>
                            </div>
                            {subExtras.length === 0
                                ? <p className="text-muted p-1">Nenhum tópico extra cadastrado.</p>
                                : (
                                    <table className="afira-table">
                                        <thead>
                                            <tr>
                                                <th>Tópicos de recepção extras</th>
                                                <th style={{ width: 120 }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {subExtras.map((topicoRecepcao, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        {this.state.editandoTopicoSub === index
                                                            ? (
                                                                <input
                                                                    type="text"
                                                                    className="input"
                                                                    value={this.state.valorEditandoSub}
                                                                    onChange={(e) => this.setState({ valorEditandoSub: e.target.value })}
                                                                    onKeyDown={(e) => { if (e.key === 'Enter') this.confirmarEdicaoSub(index) }}
                                                                />
                                                            )
                                                            : (
                                                                <span title={topicoRecepcao}>
                                                                    {topicoRecepcao}
                                                                </span>
                                                            )
                                                        }
                                                    </td>
                                                    <td className="hdv-subtable-action-td" style={{ textAlign: "center" }}>
                                                        {this.state.editandoTopicoSub === index
                                                            ? (
                                                                <button
                                                                    className="hdv-btn-forms hdv-btn-green"
                                                                    onClick={() => this.confirmarEdicaoSub(index)}
                                                                >
                                                                    Salvar
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="hdv-btn-forms hdv-btn-yellow"
                                                                    onClick={() => this.setState({ editandoTopicoSub: index, valorEditandoSub: topicoRecepcao })}
                                                                >
                                                                    Editar
                                                                </button>
                                                            )
                                                        }
                                                        <ConfirmDelete
                                                            enabled={true}
                                                            action={() => this.removerExtraSub(index)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )
                            }
                        </ModalBody>
                        <ModalFooter>
                            <button className="hdv-btn-forms hdv-btn-blue" onClick={() => this.setState({ modalTopicoSub: false, editandoTopicoSub: null })}>
                                Fechar
                            </button>
                        </ModalFooter>
                    </Modal>

                    <Modal
                        isOpen={this.state.modalAlterarSenha}
                        toggle={() => this.setState({ modalAlterarSenha: false })}
                    >
                        <ModalHeader>
                            Aviso
                        </ModalHeader>

                        <ModalBody>
                            Uma nova senha será gerada ao salvar
                        </ModalBody>

                        <ModalFooter>
                            <button
                                className="hdv-btn-forms hdv-btn-blue"
                                onClick={() => this.setState({ modalAlterarSenha: false })}
                            >
                                Fechar
                            </button>
                        </ModalFooter>
                    </Modal>

                    <div className="col-md-12" data-tour="mqtt-topicos-personalizados">
                        <label className="required" htmlFor="topico_personalizado">Tópicos MQTT</label>
                        <div className="d-flex">
                            <label className="hdv-fixed">
                                <input
                                    type="checkbox"
                                    disabled={this.state.topicoPersonalizadoSalvo}
                                    name="topico_personalizado"
                                    id="topico_personalizado"
                                    checked={detalhes.topico_personalizado}
                                    onChange={(e) => {
                                        const checked = e.target.checked

                                        if (checked && isEditing) {
                                            this.setState({ modalConfirmTopicoPersonalizado: true })
                                        } else {
                                            this.handleChange(e)
                                        }
                                    }}
                                /> Tópicos Personalizados
                            </label>
                        </div>
                    </div>

                    <div className="col-md-6" data-tour="mqtt-topico-publicar">
                        <label className="required" htmlFor="topico_publica">Publicar</label>

                        <div className="d-flex align-items-center hdv-gap-md">
                            <input
                                className="hdv-input-flex"
                                disabled={!detalhes.topico_personalizado}
                                readOnly={!detalhes.topico_personalizado}
                                type="text"
                                name="topico_publica"
                                id="topico_publica"
                                value={detalhes.topico_publica ?? ""}
                                onChange={this.handleChange}
                            />

                            {isEditing && (
                                <div className="hdv-form-action" data-tour="mqtt-topicos-extras-pub">
                                    <button
                                        type="button"
                                        className="hdv-btn-forms hdv-btn-blue w-100"
                                        disabled={btnPubDisabled}
                                        onClick={() => this.setState({ modalTopicoPub: true })}
                                    >
                                        Tópicos extras

                                        {pubExtras.length > 0 && (
                                            <span className="badge badge-light ml-1">
                                                {pubExtras.length}
                                            </span>
                                        )}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6" data-tour="mqtt-topico-receber">
                        <label className="required" htmlFor="topico_recebe">Receber</label>

                        <div className="d-flex align-items-center hdv-gap-md">
                            <input
                                className="hdv-input-flex"
                                disabled={!detalhes.topico_personalizado}
                                readOnly={!detalhes.topico_personalizado}
                                type="text"
                                name="topico_recebe"
                                id="topico_recebe"
                                value={detalhes.topico_recebe ?? ""}
                                onChange={this.handleChange}
                            />

                            {isEditing && (
                                <div className="hdv-form-action" data-tour="mqtt-topicos-extras-sub">
                                    <button
                                        type="button"
                                        className="hdv-btn-forms hdv-btn-blue w-100"
                                        disabled={btnSubDisabled}
                                        onClick={() => this.setState({ modalTopicoSub: true })}
                                    >
                                        Tópicos extras

                                        {subExtras.length > 0 && (
                                            <span className="badge badge-light ml-1">
                                                {subExtras.length}
                                            </span>
                                        )}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="col-md-6" data-tour="mqtt-usuario">
                        <label className="required" htmlFor="usuario_mqtt">Usuário</label>

                        <div className="d-flex align-items-center hdv-gap-sm">
                            <input
                                className="hdv-input-flex"
                                disabled={true}
                                type="text"
                                name="usuario_mqtt"
                                id="usuario_mqtt"
                                value={detalhes.usuario_mqtt ?? ""}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-6" data-tour="mqtt-senha">
                        <label className="required" htmlFor="senha_mqtt">Senha</label>

                        <div className="d-flex align-items-center hdv-gap-md">
                            <input
                                className="hdv-input-flex"
                                disabled={true}
                                type="text"
                                name="senha_mqtt"
                                id="senha_mqtt"
                                value={detalhes.senha_mqtt ?? ""}
                                onChange={this.handleChange}
                            />

                            {isEditing && (
                                <div className="hdv-form-action-center" data-tour="mqtt-alterar-senha">
                                    <label className="hdv-fixed hdv-nowrap mb-0">
                                        <input
                                            type="checkbox"
                                            checked={this.state.alterarSenha}
                                            onChange={(event) => {
                                                const checked = event.target.checked

                                                this.setState({
                                                    alterarSenha: checked,
                                                    modalAlterarSenha: checked
                                                })
                                            }}
                                        />

                                        {" "}Alterar senha
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )
        } else if (detalhes.tipo_comunicacao === "via_gateway") {
            return (
                <div className="row">
                    <div className="col-md-6" data-tour="gateway-select">
                        <label className="required">
                            Selecione o Gateway
                            <Select
                                value={detalhes.gateway}
                                onChange={this.handleChangeGateway}
                                options={this.state.gateways}
                                onClick={this.getGateways}
                            />
                        </label>
                        <span id="validacao-gateway_equipamento"></span>
                    </div>
                </div>
            )
        }
    }

    onLoadAcessos = (statusAcessos, all) => {
        let { tipoAcessos } = this.state

        for (let i = 0; i < tipoAcessos.length; i++) {
            let acesso = statusAcessos.find((a) => a.acesso_tipo === tipoAcessos[i].value)
            tipoAcessos[i].isDisabled = acesso?.utilizados >= acesso?.tcount
        }

        this.setState({ tipoAcessos, acessos: all })
    }

    getGateways = () => {
        axios.get(`${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/equipamento/?gateway=true`, {
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            this.setState({ gateways: res.data.results.map((gateway) => ({
                value: gateway.id,
                label: gateway.imei
            })) })
        }).catch(console.error)
    }

    buttonFormGroup = (onlyCancelar = false ) => {
        return (
            <div className="hdv-btn-group">
                {onlyCancelar ? null : (
                    <ButtonsForm
                        route="/equipamento"
                        edit={this.props.match.params.edit ? true : false}
                        cooldown={this.state.cooldown}
                        buttons={[
                            {
                                method: "post",
                                button: <button data-tour="equipamento-salvar" onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                            }, {
                                method: "post",
                                button: <button style={{ display: this.props.match.params.id ? "none" : "" }} onClick={() => this.saveAction(true)} className="hdv-btn-forms hdv-btn-greenlight">Salvar e Cadastrar um Novo</button>
                            }, {
                                method: "patch",
                                button: <button data-tour="equipamento-salvar" onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                            },
                        ]}
                    />
                )}
                <Link to={this.state.back_to ? this.state.back_to : '/equipamento'}>
                    <button className="hdv-btn-forms hdv-btn-orange">
                        Cancelar
                    </button>
                </Link>
            </div>
        )
    }

    cancelImport () {
        this.setState({ parametrosImportados: [], cards_errors_import: [], is_importando: false })
    }

    render() {
        const { detalhes, optionSelected, device_id, parametrizacoes, isVirtual, emails_notificar, savedCommunicationType } = this.state
        const selectedFabricante = optionSelected.fabricante
        const selectedModelo = optionSelected.modelo
        const selectedOperadora = optionSelected.operadora
        const selectedTimezone = optionSelected.timezone
        const selectedDecoder = optionSelected.decoder
        const selctedGateway = ""

        if (this.state.redirect) {
            history.pushState({}, "", location.href)
            return <Redirect to={this.state.path} />
        }

        const { Option } = components
        const IconOption = (props) => {
            const disabled = props.data.isDisabled
            return (
                <Option {...props}>
                    <span className="d-flex align-items-center">
                        <i style={{ fontSize: '16px', color: disabled ? "#cf2b2b" : '#2bb33f', borderRadius: "8px" }} className="fa fa-square mr-1"></i>
                        <b style={{ color: '#222', fontWeight: 'normal', opacity: disabled ? 0.7 : 1 }}>{props.data.label}</b>
                    </span>
                </Option>
            )
        }

        return (
            <div
                data-tour="equipamento-edit-root"
                data-comunicou={String(this.state.comunicou === true)}
                data-protocolo={detalhes.tipo_comunicacao || ''}
                data-protocolo-salvo={savedCommunicationType || detalhes.tipo_comunicacao || ''}
                data-is-gateway={String(Boolean(detalhes.isGateway))}
                data-is-virtual={String(Boolean(isVirtual))}
                data-tem-parametros={String((this.state.parametrizacoes?.length ?? 0) > 0)}
                data-carregado={String(Boolean(this.state.equipamentoCarregado))}
                data-form-preenchido={String(this.isFormularioPreenchido())}
            >
                <ModalAvisoTimestampBuffer
                    avisoAberto={this.state.modalAvisoBuffer}
                    confirmacaoAberta={this.state.modalConfirmarSemBuffer}
                    salvando={this.state.salvandoBufferAviso}
                    onFechar={() => this.setState({ modalAvisoBuffer: false })}
                    onCadastrarAgora={this.cadastrarTimestampDispositivo}
                    onNaoUtilizarBuffer={() => this.setState({
                        modalAvisoBuffer: false,
                        modalConfirmarSemBuffer: true,
                    })}
                    onCancelarConfirmacao={() => this.setState({
                        modalConfirmarSemBuffer: false,
                        modalAvisoBuffer: true,
                    })}
                    onConfirmarDispensa={this.dispensarAvisoBuffer}
                />

                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc" style={{ alignItems: 'center' }}>
                        {this.props.match.params.id ? <h4>Editar Equipamento</h4> : <h4>Novo Equipamento</h4>}
                        <div className="gray-background">
                            <i className="fa fa-hdd fa-2x"></i>
                        </div>
                        {auth.isMasterOrAdmin() ? (
                        <span
                            data-tour="help-equipamento-form"
                            title="Ajuda"
                            onClick={() => {
                                if (this.props.match.params.id) {
                                    tourManager.start('editar-equipamento')
                                } else {
                                    tourManager.start('novo-equipamento')
                                }
                            }}
                            style={{ marginLeft: '10px', display: 'flex', alignItems: 'center' }}
                        >
                            <i className="las la-question-circle hdv-help-tour-icon"></i>
                        </span>
                        ) : null}
                    </span>
                </div>

                <Tabs className="tabs-style" selectedIndex={this.state.tab} onSelect={(i) => this.handleTab(i)}>
                    <TabList>
                        <Tab data-tour="tab-equipamento">Equipamento</Tab>
                        <Tab data-tour="tab-protocolo" disabled={isVirtual}>Protocolo</Tab>

                        {!detalhes.isGateway && (
                            <>
                                <Tab data-tour="tab-parametrizacao" disabled={!Boolean(this.props.match.params.id)}>
                                    Parametrização
                                </Tab>

                                <Tab data-tour="tab-comandos" disabled={!Boolean(this.props.match.params.id) || isVirtual}>
                                    Comandos
                                </Tab>
                            </>
                        )}

                        {(detalhes.tipo_comunicacao === "mqtt" || !this.props.match.params.id) && (
                            <Tab data-tour="tab-dados-vivo" disabled={!Boolean(this.props.match.params.id) || detalhes.tipo_comunicacao !== "mqtt"}>
                                Dados Ao Vivo <i className="las la-podcast la-lg text-danger icone-aba-piscar"></i>
                            </Tab>
                        )}
                    </TabList>

                    <TabPanel>
                        <div className="hdv-form-default" style={{ minHeight: "370px" }}>
                            <div className="row">
                                <div className={detalhes?.acesso ? "col-md-9" : "col-md-12"} data-tour="form-imei">
                                    <label className="required" htmlFor="razao_social">IMEI</label>
                                    <input disabled={(this.props.match.params.id) ? true : false} type="text" name="imei" id="imei" value={detalhes.imei} onChange={this.handleChange} />
                                    <span id="validacao-imei"></span>
                                </div>

                                {detalhes?.acesso ?
                                    <div className="col-md-3" data-tour="form-estado-acesso">
                                        <label className="required" htmlFor="razao_social">Estado do acesso</label>
                                        <progress value={parametrizacoes?.length} max={detalhes?.acesso?.limite} style={{ width: "100%" }} />
                                        <div>
                                            {`${parametrizacoes?.length} / ${detalhes?.acesso?.limite ?? ""}`}
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>

                            <div className="row">
                                <div className="col-md-4" data-tour="form-fabricante">
                                    <label className="required">Fabricante</label>
                                    <Select
                                        value={selectedFabricante}
                                        onChange={(e) => this.handleChangeFabricante(e, 'fabricante')}
                                        options={this.state.fabricantes}
                                        disabled={isVirtual}
                                    />
                                    <span id="validacao-fabricante"></span>
                                </div>

                                <div className="col-md-4" data-tour="form-modelo">
                                    <label className="required">Modelo</label>
                                    <Select
                                        value={selectedModelo}
                                        name="modelo"
                                        onChange={(e) => this.handleChangeModelo(e, 'modelo')}
                                        options={this.state.modelos}
                                        disabled={isVirtual}
                                    />
                                    <span id="validacao-modelo"></span>
                                </div>

                                <div className="col-md-4" data-tour="form-decoder">
                                    <label htmlFor="decoder">Decoder</label>
                                    <Select
                                        value={selectedDecoder}
                                        name="decoder"
                                        isClearable
                                        disabled={!selectedModelo?.value}
                                        placeholder={selectedModelo?.value ? "Selecione" : "Selecione um modelo primeiro"}
                                        onChange={(e) => this.handleChangeSelect(e ?? { value: null, label: "" }, 'decoder')}
                                        options={this.state.decoders}
                                    />
                                    <span id="validacao-decoder"></span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6" data-tour="form-comunicacao">
                                    <label className="required">Comunicação</label>
                                    <Select
                                        value={selectedOperadora}
                                        name="operadora"
                                        disabled={isVirtual}
                                        onChange={(e) => this.handleChangeSelect(e, 'operadora')}
                                        options={this.state.operadoras}
                                    />
                                    <span id="validacao-operadora"></span>
                                </div>

                                <div className="col-md-6" data-tour="form-simcard">
                                    <label className="required" htmlFor="sim_card">Número do SimCard</label>
                                    <input type="text" name="sim_card" id="sim_card" value={detalhes.sim_card} onChange={this.handleChange} disabled={!Boolean(this.state.optionSelected?.operadora?.possui_chip)} />
                                    <span id="validacao-sim_card"></span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6" data-tour="form-emails">
                                    <label className='required'>Tempo limite sem comunicação</label>

                                    <div className='row align-items-center'>
                                        <div className='col-md-8'>
                                            <input
                                                type="number"
                                                name="tempo_limite_sem_comunicacao"
                                                value={this.state.detalhes.tempo_limite_sem_comunicacao || 0}
                                                min='0'
                                                placeholder='Em minutos'
                                                onChange={(e) => {
                                                    let detalhes = { ...this.state.detalhes }
                                                    let value = e.target.value?.replace(/-/g, "").replace(/e/g, "")
                                                    detalhes.tempo_limite_sem_comunicacao = value
                                                    this.setState({ detalhes })
                                                }}
                                            />
                                        </div>
                                        <ModalEmail
                                            emails={emails_notificar}
                                            setEmails={(emails) => this.setState({ emails_notificar: emails })}
                                            tempo_limite_sem_comunicacao={detalhes.tempo_limite_sem_comunicacao}
                                            sim_card={detalhes.sim_card}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6" data-tour="form-timezone">
                                    <label className="required">Timezone</label>
                                    <Select
                                        value={selectedTimezone}
                                        name="timezone"
                                        onChange={(e) => this.handleChangeSelect(e, 'timezone')}
                                        options={this.state.timezones}
                                    />
                                    <span id="validacao-timezone"></span>
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-md-6" style={{ paddingBottom: 20 }}>
                                    <div className='row'>
                                        <div className="col-md-3" data-tour="form-gateway-check">
                                            <label className="required">Gateway</label>
                                            <input disabled={this.props.match.params.id ? true : false} checked={detalhes.isGateway} id="isGateway" onChange={this.handleChange} type="checkbox" style={{ marginLeft: 2 }} />
                                        </div>

                                        <div className="col-md-6" data-tour="form-status">
                                            <label className="required" htmlFor="status">Status</label>
                                            <div className="d-flex">
                                                <label className="hdv-fixed">
                                                    <input type="radio" name="status" id="status" checked={detalhes.status === 'ativo'} value="ativo" onChange={this.handleChange} /> Ativo
                                                </label>
                                                <label className="hdv-fixed">
                                                    <input type="radio" name="status" id="status" checked={detalhes.status === 'bloqueado'} value="bloqueado" onChange={this.handleChange} /> Bloqueado
                                                </label>
                                                <label style={{ paddingRight: "50px" }} className="hdv-fixed">
                                                    <input type="radio" name="status" id="status" checked={detalhes.status === 'cancelado'} value="cancelado" onChange={this.handleChange} /> Cancelado
                                                </label>
                                            </div>
                                            <span id="validacao-status"></span>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div style={{ display: detalhes.isGateway ? "block" : "none" }} data-tour="form-campo-gateway">
                                        <label className="required" htmlFor="campo_gateway">Campo ID do equipamento</label>
                                        <input type="text" name="campo_gateway" id="campo_gateway" value={detalhes.campo_gateway ?? ""} onChange={this.handleChange} disabled={!Boolean(this.state.detalhes.isGateway)} />
                                        <span id="validacao-campo_gateway"></span>
                                    </div>

                                    <div style={{ display: detalhes.isGateway ? "none" : "block" }} data-tour="form-tipo-acesso">
                                        <label className="required">Tipo do Acesso</label>
                                        <div className='row'>
                                            <div className="col-md-8">
                                                <Select
                                                    components={{ Option: IconOption }}
                                                    value={optionSelected.tipo_acesso}
                                                    name="tipo_acesso"
                                                    disabled={!Boolean(detalhes.status === 'ativo')}
                                                    onChange={(e) => this.handleChangeSelect(e, "tipo_acesso")}
                                                    options={this.state.tipoAcessos}
                                                />
                                            </div>
                                            <div className="col-md-4" style={{ paddingLeft: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <ProgressAcessos
                                                    className="float-right"
                                                    onLoad={this.onLoadAcessos}
                                                    style={{ margin: 0, width: "100%" }}
                                                />
                                            </div>
                                        </div>
                                        <span id="validacao-tipo_acesso"></span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {this.buttonFormGroup()}
                    </TabPanel>
                    <TabPanel>
                        <div className="hdv-form-default">
                            <div className="row">
                                <div className="col-md-12">
                                    <label className="required" htmlFor="tipo_comunicacao">Protocolo</label>
                                    <div style={{ display: 'flex' }} data-tour="form-protocolo-opcoes">
                                        <div>
                                            <label className="hdv-fixed" data-tour="protocol-mqtt">
                                                <input type="radio" name="tipo_comunicacao" id="tipo_comunicacao" checked={detalhes.tipo_comunicacao === 'mqtt'} value="mqtt" onChange={this.handleChange} /> MQTT
                                            </label>
                                        </div>
                                        <div style={{ display: detalhes.isGateway ? "none" : "block" }}>
                                            <label className="hdv-fixed" data-tour="protocol-gateway">
                                                <input type="radio" name="tipo_comunicacao" id="tipo_comunicacao" checked={detalhes.tipo_comunicacao === 'via_gateway'} value="via_gateway" onChange={this.handleChange} /> Gateway
                                            </label>
                                        </div>
                                        <div>
                                            <label className="hdv-fixed" data-tour="protocol-http">
                                                <input type="radio" name="tipo_comunicacao" id="tipo_comunicacao" checked={detalhes.tipo_comunicacao === 'http'} value="http" onChange={this.handleChange} /> HTTP
                                            </label>
                                        </div>
                                        {savedCommunicationType === 'lns_interno' && <div>
                                            <label className="hdv-fixed" data-tour="protocol-lns">
                                                <input type="radio" name="tipo_comunicacao" id="tipo_comunicacao" checked={detalhes.tipo_comunicacao === 'lns_interno'} value="lns_interno" onChange={this.handleChange} /> LNS
                                            </label>
                                        </div>}
                                        <div>
                                            <label className="hdv-fixed" data-tour="protocol-outro">
                                                <input type="radio" name="tipo_comunicacao" id="tipo_comunicacao" checked={detalhes.tipo_comunicacao === 'outro'} value="outro" onChange={this.handleChange} /> Outro
                                            </label>
                                        </div>
                                    </div>
                                    <span id="validacao-tipo_comunicacao"></span>
                                </div>
                            </div>
                            {this.renderComunicacao()}
                            <br />

                            <div
                                data-tour={`detalhes-comunicacao-${detalhes.tipo_comunicacao}`}
                                style={{ display: ['http', 'mqtt', 'lns_interno'].includes(detalhes.tipo_comunicacao) ? "block" : "none" }}>
                                <label style={{ fontWeight: "bold" }}>Detalhes da comunicação</label>
                                <div className='container-detalhes-comunicacao'>
                                    <div>
                                        {
                                            detalhes.tipo_comunicacao === 'http' ?
                                                <div>
                                                    <p><strong>Url:</strong> https://data.afira.io/device/{device_id}/</p>
                                                    <p><strong>Métodos:</strong> <Badge color="success">GET</Badge><Badge color="danger">POST</Badge></p>
                                                </div>
                                            :  detalhes.tipo_comunicacao === 'mqtt' ?
                                                <div>
                                                    <p><strong>Servidor:</strong> message.afira.io</p>
                                                    <p><strong>Portas:</strong> 1883 e SSL/TLS:8883</p>
                                                </div>
                                            : 
                                                <div>
                                                    <p>Este protocolo depende de redirecionamentos no módulo LNS. Para cadastrar um novo equipamento, crie-o como dispositivo no LNS e adicione um redirecionamento interno. O cadastro será concluído via interação nos redirecionamentos.</p>
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.buttonFormGroup()}
                    </TabPanel>

                    {!detalhes.isGateway ?
                        <>
                            <TabPanel>
                                {(this.props.match.params.id)
                                    ?
                                    this.state.is_importando ? (
                                        <div className="finalizar-importacao">
                                            <button className="hdv-btn-forms hdv-btn-orange" onClick={() => this.cancelImport()}>
                                                Cancelar
                                            </button>
                                            <button
                                                className="hdv-btn-forms hdv-btn-green"
                                                disabled={this.state.parametrosImportados.some(parametro => !parametro.descricao?.trim())}
                                                onClick={() => this.saveImport()}
                                            >
                                                Finalizar importação
                                            </button>
                                        </div>
                                    ) : (
                                        <TemplateParametrizacao
                                            detalhes={this.state.detalhes}
                                            allowNewParam={this.state.allowNewParam}
                                            fabricante={this.state.optionSelected?.fabricante}
                                            modelo={this.state.optionSelected?.modelo}
                                            parametrizacoes={this.state.parametrizacoes}
                                            getData={this.getParametros}
                                            setCardsErrors={(parametros) => this.setState({ cards_errors_import: parametros })}
                                            subirParametrosImportados={this.subirParametrosImportados}
                                        />
                                    )
                                    :
                                    null
                                }
                                <div>
                                    {(!this.props.match.params.id)
                                        ?
                                        <span className="equipamento-info-parametrizacao">
                                            💾 <strong>&nbsp; Salve o equipamento &nbsp;</strong> e aguarde sua comunicação para configurar os valores!
                                        </span>
                                        :
                                        (this.state.comunicou !== true && this.state.parametrizacoes.length === 0 && !isVirtual && !this.state.is_importando)
                                            ?
                                            <span className="equipamento-info-parametrizacao" data-tour="param-aviso-comunicacao" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 6 }}>
                                                <span>⏳ Aguarde a comunicação do equipamento para configurar os valores!</span>
                                                {this.state.comunicou === false && (
                                                    <span style={{ color: "#888", fontSize: "0.9em" }}>
                                                        Verificando novamente em {this.state.proximaVerificacao}s...
                                                    </span>
                                                )}
                                            </span>
                                            :
                                            <div className="box-list-novo-parametrizacao">
                                                <div className={this.state.allowNewParam ? "parametrizacao-btn-novo" : "parametrizacao-btn-novo disabled"} data-tour="param-novo-btn">
                                                    <Link
                                                        to={{ pathname: `/campo-parametrizado/${detalhes.id}/novo`, state: { id: detalhes.id } }}
                                                        style={{ pointerEvents: this.state.allowNewParam ? "all" : "none" }}
                                                    >
                                                        <i className="fa fa-plus-circle"></i> <span>Novo Parâmetro</span>
                                                    </Link>
                                                    <span id="warning">Esse equipamento atingiu o limite de parâmetros. Utilize outro acesso ou contate um administrador!</span>
                                                </div>
                                                {this.state.parametrizacoes?.map((parametrizacao, index) => (
                                                    <CardParametrizacao
                                                        key={index}
                                                        detalhes={detalhes}
                                                        parametrizacao={parametrizacao}
                                                        getParametros={this.getParametros}
                                                    />
                                                ))}

                                                {
                                                    this.state.is_importando &&
                                                    this.state.parametrosImportados?.map((parametro, index) => (
                                                        <EditableCardParametrizacao
                                                            key={`importado-${index}`}
                                                            index={index}
                                                            detalhes={detalhes}
                                                            parametrizacao={parametro}
                                                            getParametros={this.getParametros}
                                                            removerParametroImportado={this.removerParametroImportado}
                                                            updateParametroImportado={this.updateParametroImportado}
                                                        />
                                                    ))
                                                }

                                                {this.state.cards_errors_import.map((parametro, index, array) => (
                                                    <CardErrorParametrizacao
                                                        equipamentoId={detalhes.id}
                                                        key={`erro-${index}`}
                                                        index={index}
                                                        parametrizacao={parametro}
                                                        cardsErrors={array}
                                                        setCardsErrors={(parametros) => this.setState({ cards_errors_import: parametros })}
                                                        getParametros={this.getParametros}
                                                    />
                                                ))}
                                            </div>
                                    }
                                </div>
                                {this.buttonFormGroup(true)}
                            </TabPanel>
                            <TabPanel>
                                {(this.props.match.params.id)
                                    ?
                                    <TemplateComando
                                        detalhes={this.state.detalhes}
                                        fabricante={this.state.optionSelected?.fabricante}
                                        modelo={this.state.optionSelected?.modelo}
                                        comandos={this.state.comandos}
                                        getData={this.getComandos}
                                    />
                                    :
                                    null
                                }
                                <div className="box-list-novo-comandos">
                                    {(!this.props.match.params.id || !detalhes.imei) ?
                                        <span className="equipamento-info-parametrizacao">
                                            💾 <strong>&nbsp; Salve o equipamento &nbsp;</strong> para adicionar comandos!
                                        </span>
                                        :
                                        <>
                                            <div className="comandos-btn-novo" data-tour="cmd-novo-btn">
                                                <Link to={{ pathname: `/comando-customizado/${this.props.match.params.id}/novo`, state: { id: detalhes.id, tipo_comunicacao: detalhes.tipo_comunicacao } }} >
                                                    <i className="fa fa-plus-circle"></i> <span>Novo Comando</span>
                                                </Link>
                                            </div>

                                            {this.state.comandos?.map((comando, index) => (
                                                <CardComando width="200px" key={index} getComandos={this.getComandos} comando={comando} />
                                            ))}
                                        </>
                                    }
                                </div>
                                {this.buttonFormGroup(true)}
                            </TabPanel>
                        </>
                        : null
                    }
                    {(detalhes.tipo_comunicacao === "mqtt" || !this.props.match.params.id) && (
                        <TabPanel>
                            <MqttPreview deviceId={this.state.device_id} />
                        </TabPanel>
                    )}
                </Tabs>

                <ConfirmarEmailModal
                    isOpen={this.state.modalConfirmarEmail.isOpen}
                    email={this.state.modalConfirmarEmail.email}
                    toggle={() => this.setState({ modalConfirmarEmail: { isOpen: false, email: null } })}
                    onConfirmado={this.handleEmailConfirmado}
                    onContinuarSemConfirmar={this.handleContinuarSemConfirmar}
                />
            </div>
        )
    }
}

export default Form
